import { useCallback } from 'react'
import TChecklistTask from '../TChecklistTask'
import { TChecklistModelType } from '@teinor/erp/types/company/config/customerProject/tChecklist'
import { TChecklistSectionModelType } from '@teinor/erp/types/company/config/customerProject/tChecklist/tChecklistSection'
import { twinFetchPostJSON } from '../../../../../../../utils/globals/data'
import { getUserPermissions } from '../../../../../../../utils/reducers/getters'
import ChecklistSection from '../../../../../../../baseComponents/Checklist/ChecklistSection'

interface TChecklistSectionProps extends TChecklistSectionLogicProps { 
    addSection: ()=>void
}


const TChecklistSection: React.FC<TChecklistSectionProps> = ({ section, addSection, ...logic }) => {
    const { updateNameSection, addTChecklistTask, deleteTChecklistSection, userPermission } = useTChecklistSectionLogic({ section, ...logic })
    const renderThis: JSX.Element[] = []
    if (section.TChecklistTasks?.length) {
        for (const key in section.TChecklistTasks) {
            const task = section.TChecklistTasks[key]
            renderThis.push(<TChecklistTask key={task.id} posTask={parseInt(key)} task={task} addTask={addTChecklistTask} {...logic} />)
        }
    }
    return (
        <div className='mb-30'>
            <ChecklistSection section={section} userPermission={userPermission} onChangeSection={updateNameSection} onDeleteSection={deleteTChecklistSection} onAddTask={addTChecklistTask} addSection={addSection} />
            {renderThis.length ?
                <div className='ml-16 tchecklist-task-container' >
                    <div className='border-b border-gray-EE' />
                    {renderThis}
                </div>
                :
                null
            }
        </div>
    )
}

interface TChecklistSectionLogicProps {
    posSection: number
    section: TChecklistSectionModelType
    setDataChecklist: React.Dispatch<React.SetStateAction<TChecklistModelType>>
    refChecklistSection: React.MutableRefObject<any>
}

const useTChecklistSectionLogic = ({ posSection, section, setDataChecklist, refChecklistSection }: TChecklistSectionLogicProps) => {
    const userPermission = getUserPermissions('config.customerProject.templateChecklist')

    const handleChangeNameSection = useCallback((value: string) => {
        setDataChecklist((old) => {
            const copyOld = JSON.parse(JSON.stringify(old))
            if (copyOld.TChecklistSections && copyOld.TChecklistSections.length) {
                copyOld.TChecklistSections[posSection].name = value
            }
            return { ...copyOld }
        })
    }, [setDataChecklist, posSection])

    const updateNameSection = useCallback(async (value: string) => {
        if (value !== section.name) {
            handleChangeNameSection(value)
            await twinFetchPostJSON('/api/app/config/templateChecklist/section/updateTChecklistSection', { id: section.id, name: value })
        }
    }, [section.id, section.name, handleChangeNameSection])

    const addTChecklistTask = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/config/templateChecklist/section/task/createTChecklistTask', { TChecklistSectionId: section.id, name: '' })
        if (result) {
            setDataChecklist((old) => {
                const copyOld = JSON.parse(JSON.stringify(old))
                if (copyOld.TChecklistSections && copyOld.TChecklistSections.length) {
                    const mySection = copyOld.TChecklistSections[posSection]
                    if (!mySection?.TChecklistTasks) {
                        copyOld.TChecklistSections[posSection].TChecklistTasks = []
                    }
                    copyOld.TChecklistSections[posSection].TChecklistTasks.push({ ...result })
                }
                return { ...copyOld }
            })
            setTimeout(() => {
                refChecklistSection.current?.children[posSection]?.lastChild?.lastChild?.getElementsByClassName('input_change_checklist_task_name')[0]?.getElementsByClassName('rectangular_textarea')[0]?.children[0].focus()
            }, 100)
        }
    }, [section.id, setDataChecklist, posSection, refChecklistSection])

    const deleteTChecklistSection = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/config/templateChecklist/section/deleteTChecklistSection', { id: section.id })
        if (result) {
            setDataChecklist((old) => {
                const copyOld = JSON.parse(JSON.stringify(old))
                if (copyOld.TChecklistSections && copyOld.TChecklistSections.length) {
                    copyOld.TChecklistSections.splice(posSection, 1)
                }
                return { ...copyOld }
            })
        }
    }, [posSection, section.id, setDataChecklist])

    return { updateNameSection, addTChecklistTask, deleteTChecklistSection, userPermission }
}
export default TChecklistSection